/**
 * @fileoverview gRPC-Web generated client stub for 
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v7.34.1
// source: message.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as message_pb from './message_pb'; // proto import: "message.proto"


export class MessageServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorStreamMessages = new grpcWeb.MethodDescriptor(
    '/MessageService/StreamMessages',
    grpcWeb.MethodType.SERVER_STREAMING,
    message_pb.ClientInfo,
    message_pb.ServerMessage,
    (request: message_pb.ClientInfo) => {
      return request.serializeBinary();
    },
    message_pb.ServerMessage.deserializeBinary
  );

  streamMessages(
    request: message_pb.ClientInfo,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<message_pb.ServerMessage> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/MessageService/StreamMessages',
      request,
      metadata || {},
      this.methodDescriptorStreamMessages);
  }

}

